import React from 'react';
import { Formik } from 'formik';
import { FormattedMessage, injectIntl } from 'react-intl';
import 'react-dates/initialize.js';
import 'react-dates/lib/css/_datepicker.css';

import SingleDatePickerComponent
	from '../../../components/single-date-picker/single-date-picker.component.js';
import ExperiencesService from '../../experiences/experiences.service.js';

import './heading.section.scss';
import PriceRange from '../../../components/popovers/price/price.component.js';
import Autocomplete from '../../../components/forms/autocomplete.field.js';
import CustomSelect from '../../../components/custom-select/custom-select.component.js';

import { ReactComponent as Icon } from '../../../assets/images/tour/ico_category.svg';

const MINPRICE = 0;
const MAXPRICE = 1000;

const BookExperienceButton = ({ label, onClick }) => (
	<button className="btn blue book-experience-button" type="button" onClick={onClick}>
		{label}
	</button>
);

const SearchBar = ({
	intl, handleSubmit, categories, rangePrice,
}) => {
	const escapeRegexCharacters = str => (
		str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
	);

	const getSuggestions = async (value) => {
		const escapedValue = escapeRegexCharacters(value.trim());
		if (escapedValue === '') {
			return [];
		}

		const { locale } = intl;
		const { data } = await ExperiencesService.getExperiences(
			locale,
			1,
			9,
			{ search: value, sort: 'name', sortDirection: 'asc' },
		);
		return data.map(experience => experience.name);
	};

	return (
		<Formik
			initialValues={
				{
					date: null,
					search: null,
					price: {
						min: rangePrice ? rangePrice.min : MINPRICE,
						max: rangePrice ? rangePrice.max : MAXPRICE,
					},
					category: null,
				}}
			onSubmit={(values, { setSubmitting }) => {
				setSubmitting(false);
				handleSubmit(values);
			}}
		>
			{({ setFieldValue, values, submitForm }) => (
				<div className="search-bar row middle-xs center-xs">
					<div className="col-xs-12 col-sm-12 col-md-4 middle-xs field search">
						<Autocomplete
							name="search"
							formValues={values}
							setFieldValue={setFieldValue}
							getSuggestions={getSuggestions}
						/>
					</div>

					<div className="col-xs-12 col-sm-6 col-md-2 middle-xs field">
						<SingleDatePickerComponent
							placeholder={intl.formatMessage({
								id: 'formik.date',
							})}
							setFieldValue={setFieldValue}
							name="date"
							icon
							tinyBar
						/>
					</div>

					<div className="col-xs-12 col-sm-6 col-md-2 middle-xs field">
						<CustomSelect
							placeholder={intl.formatMessage({ id: 'search-bar.category' })}
							name="category"
							fieldName="category"
							setFieldValue={setFieldValue}
							options={categories}
							isClearable
							icon={<Icon />}
						/>
					</div>

					<div className="col-xs-12 col-md-2 middle-xs field">
						<PriceRange
							values={values}
							minPrice={rangePrice ? rangePrice.min : MINPRICE}
							maxPrice={rangePrice ? rangePrice.max : MAXPRICE}
							smallBar
						/>
					</div>

					<div className="col-xs-12 col-sm-12 col-md-2 middle-xs field">
						<BookExperienceButton label={intl.formatMessage({ id: 'button.search-experience' })} onClick={submitForm} />
					</div>
				</div>
			)}
		</Formik>
	);
};


const Heading = ({
	intl, handleSubmit, categories, rangePrice,
}) => (
	<div className="heading">
		<div className="titles row">
			<div className="col-xs-12 center-xs start-md col-md-6">
				<span className="title"><FormattedMessage id="checkout.header.title" /></span>
			</div>
		</div>

		<SearchBar
			handleSubmit={handleSubmit}
			intl={intl}
			categories={categories}
			rangePrice={rangePrice}
		/>
	</div>
);

export default injectIntl(Heading);
